import { useState } from "react";
import { apiFetch } from "@/lib/api-client";
import type {
  CreateTaxDocumentInput,
  CreateTaxDocumentResponse,
} from "../types";

export interface UseCreateTaxDocumentResult {
  createDocument: (
    input: CreateTaxDocumentInput,
  ) => Promise<CreateTaxDocumentResponse>;
  isLoading: boolean;
  error: Error | null;
}

export function useCreateTaxDocument(): UseCreateTaxDocumentResult {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const createDocument = async (
    input: CreateTaxDocumentInput,
  ): Promise<CreateTaxDocumentResponse> => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await apiFetch.post<CreateTaxDocumentResponse>(
        "/api/tax-documents",
        input,
      );
      return response;
    } catch (err) {
      const error =
        err instanceof Error ? err : new Error("Failed to create document");
      setError(error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    createDocument,
    isLoading,
    error,
  };
}
